export default "__VITE_ASSET__Jld3Mb6I__"